module.exports = __webpack_public_path__ + "img/mantaCuraConcreto2.a1a1aa27.png";